import request from "lib/request"
import config from "config/app"
import lib from 'lib/commons'

export const CURRENT_USER_REQUEST         = 'CURRENT_USER_REQUEST'
export const CURRENT_USER_REQUEST_ERROR   = 'CURRENT_USER_REQUEST_ERROR'
export const CURRENT_USER_REQUEST_SUCCESS = 'CURRENT_USER_REQUEST_SUCCESS'
export const CURRENT_USER_FETCHING        = 'CURRENT_USER_FETCHING'

export const ATTEND = 'ATTEND'
export const ATTEND_SUCCESS = 'ATTEND_SUCCESS'
export const ATTEND_ERROR = 'ATTEND_ERROR'
export const IS_ATTENDING = 'IS_ATTENDING'

export const BUY = 'BUY'
export const BUY_SUCCESS = 'BUY_SUCCESS'
export const BUY_ERROR = 'BUY_ERROR'
export const IS_BUYING = 'IS_BUYING'

export const CLAIM = 'CLAIM'
export const CLAIM_SUCCESS = 'CLAIM_SUCCESS'
export const CLAIM_ERROR = 'CLAIM_ERROR'
export const IS_CLAIMING = 'IS_CLAIMING'

export const EXCHANGE = 'EXCHANGE'
export const EXCHANGE_SUCCESS = 'EXCHANGE_SUCCESS'
export const EXCHANGE_ERROR = 'EXCHANGE_ERROR'
export const IS_EXCHANGING = 'IS_EXCHANGING'


export const GET_HISTORY = 'GET_HISTORY'
export const GET_HISTORY_SUCCESS = 'GET_HISTORY_SUCCESS'
export const GET_HISTORY_ERROR = 'GET_HISTORY_ERROR'
export const IS_GETTING_HISTORY = 'IS_GETTING_HISTORY'

export const isCurrentUserFetching = () => {
  return {
    type: CURRENT_USER_FETCHING
  }
}

export const getCurrentUser = () => {
  return (dispatch, getState) => {
    dispatch(isCurrentUserFetching());
    request('api/user/get').then(function(response) {
      if(response.status == 'successful') {
        dispatch(getCurrentUserSuccess(response));
      } else {
        dispatch(getCurrentUserError(response))
      }
    })
  }
}

export const getCurrentUserSuccess = (response) => {
  return {
    type: CURRENT_USER_REQUEST_SUCCESS,
    payload: response.payload
  }
}

export const getCurrentUserError = (response) => {
  return {
    type: CURRENT_USER_REQUEST_ERROR,
    payload: response.payload
  }
}


//Attend
export const isAttending = () => {
  return {
    type: IS_ATTENDING
  }
}

export const attend = (day) => {
  return (dispatch, getState) => {
    dispatch(isAttending());
    request('api/daily/claim_daily_rewards', 'POST', {
      body: JSON.stringify({
      })
    }).then(function(response) {
      if(response.status == 'successful') {
        let dailyInfo = lib.toObj(getState().currentUser.days, 'day')
        Swal.fire({
          title: 'Điểm danh thành công',
          'html': '<p>Bạn nhận được <span class="highlight">' + dailyInfo[day].display_name + '</span></p>',
          confirmButtonText: 'Xác nhận',
          showCloseButton: true,
          customClass: {
            popup: 'popup-small'
          },
        })
        dispatch(attendSuccess(response));
      } else {
        Swal.fire({
          title: 'Có lỗi',
          'html': '<p>' + lib.showError(response.error_code) + '</p>',
          confirmButtonText: 'Xác nhận',
          showCloseButton: true,
          customClass: {
            popup: 'popup-small'
          },
        })
        dispatch(attendError(response.error_code))
      }
    })
  }
}

export const attendSuccess = (response) => {
  return {
    type: ATTEND_SUCCESS,
    payload: response
  }
}

export const attendError = (response) => {
  return {
    type: ATTEND_ERROR,
    payload: response
  }
}

//Buy
export const isBuying = () => {
  return {
    type: IS_BUYING
  }
}

export const buy = (day) => {
  return (dispatch, getState) => {
    dispatch(isBuying());
    request('api/daily/buy_daily_rewards', 'POST', {
      body: JSON.stringify({
        date: day
      })
    }).then(function(response) {
      if(response.status == 'successful') {
        let dailyInfo = lib.toObj(getState().currentUser.days, 'day')
        Swal.fire({
          title: 'Điểm danh thành công',
          'html': '<p>Bạn nhận được <span class="highlight">' + dailyInfo[day].display_name + '</span></p>',
          confirmButtonText: 'Xác nhận',
          showCloseButton: true,
          customClass: {
            popup: 'popup-small'
          },
        })
        dispatch(buySuccess(response));
      } else {
        Swal.fire({
          title: 'Có lỗi',
          'html': '<p>' + lib.showError(response.error_code) + '</p>',
          confirmButtonText: 'Xác nhận',
          showCloseButton: true,
          customClass: {
            popup: 'popup-small'
          },
        })
        dispatch(buyError(response.error_code))
      }
    })
  }
}

export const buySuccess = (response) => {
  return {
    type: BUY_SUCCESS,
    payload: response
  }
}

export const buyError = (response) => {
  return {
    type: BUY_ERROR,
    payload: response
  }
}

//Claim
export const isClaiming = (stage) => {
  return {
    type: IS_CLAIMING,
    payload: stage
  }
}

export const claim = (stage) => {
  return (dispatch, getState) => {
    dispatch(isClaiming(stage));
    request('api/daily/claim_stage_rewards', 'POST', {
      body: JSON.stringify({
        stage: parseInt(stage),
        config_id: getState().currentUser.configId
      })
    }).then(function(response) {
      if(response.status == 'successful') {
        let stageInfo = lib.toObj(getState().currentUser.stages, 'stage')
        Swal.fire({
          title: 'Chúc mừng',
          'html': '<p>Bạn đã nhận được <span class="highlight">' + stageInfo[stage].display_name + '</span></p>',
          confirmButtonText: 'Xác nhận',
          showCloseButton: true,
          customClass: {
            popup: 'popup-small'
          },
        })
        dispatch(claimSuccess(response));
      } else {
        Swal.fire({
          title: 'Có lỗi',
          'html': '<p>' + lib.showError(response.error_code) + '</p>',
          confirmButtonText: 'Xác nhận',
          showCloseButton: true,
          customClass: {
            popup: 'popup-small'
          },
        })
        dispatch(claimError(response.error_code))
      }
    })
  }
}

export const claimSuccess = (response) => {
  return {
    type: CLAIM_SUCCESS,
    payload: response
  }
}

export const claimError = (response) => {
  return {
    type: CLAIM_ERROR,
    payload: response
  }
}
//Exchange
export const isExchanging = (id) => {
  return {
    type: IS_EXCHANGING,
    payload: id
  }
}

export const exchange = (item) => {
  return (dispatch, getState) => {
    dispatch(isExchanging(item.exchange_id));
    request('api/daily/claim_exchange_rewards', 'POST', {
      body: JSON.stringify({
        exchange_id: parseInt(item.exchange_id),
        config_id: getState().currentUser.configId
      })
    }).then(function(response) {
      if(response.status == 'successful') {
        Swal.fire({
          title: 'Chúc mừng',
          'html': '<p>Bạn đã nhận được <span class="highlight">' + item.display_name + '</span></p>',
          confirmButtonText: 'Xác nhận',
          showCloseButton: true,
          customClass: {
            popup: 'popup-small'
          },
        })
        dispatch(exchangeSuccess(response.payload));
      } else {
        Swal.fire({
          title: 'Có lỗi',
          'html': '<p>' + lib.showError(response.error_code) + '</p>',
          confirmButtonText: 'Xác nhận',
          showCloseButton: true,
          customClass: {
            popup: 'popup-small'
          },
        })
        dispatch(exchangeError(response.error_code))
      }
    })
  }
}

export const exchangeSuccess = (response) => {
  return {
    type: EXCHANGE_SUCCESS,
    payload: response
  }
}

export const exchangeError = (response) => {
  return {
    type: EXCHANGE_ERROR,
    payload: response
  }
}
//History
export const isGettingHistory = () => {
  return {
    type: IS_GETTING_HISTORY
  }
}

export const getHistory = () => {
  return (dispatch, getState) => {
    dispatch(isGettingHistory());
    request('api/daily/get_token_history').then(function(response) {
      if(response.status == 'successful') {
        dispatch(getHistorySuccess(response));
      } else {
        dispatch(getHistoryError(response))
      }
    })
  }
}

export const getHistorySuccess = (response) => {
  return {
    type: GET_HISTORY_SUCCESS,
    payload: response.payload
  }
}

export const getHistoryError = (response) => {
  return {
    type: GET_HISTORY_ERROR,
    payload: response.payload
  }
}


// WEBPACK FOOTER //
// ./src/authentication/actions.js